export const Browser = "Browser";
export const Extension = "Extension";
